// extracted by mini-css-extract-plugin
module.exports = {"updateSection":"ForPeriodTitleSection_updateSection__25WN4","updateIconFetching":"ForPeriodTitleSection_updateIconFetching__5dCqy","show":"ForPeriodTitleSection_show__39TXZ"};